import "./assets/css/App.css";
import logo from './assets/imgs/logo_transparent_bkgnd.png';

// import NavBar from "./components/NavBar";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <div id="wrapper">
        {/* <NavBar /> */}
        <div id="sectionheader" className="section_container"></div>
        <div id="sectiontitle" className="section_container">
          <img src={logo} alt="Elevate Engineering" width="25%" height="auto" />
        </div>
        <div className="spacer"></div>
        <Footer />
      </div>
    </div>
  );
}

export default App;
